var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout bg--main"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("台灣鬼怪不只林投姐與魔神仔？"),_c('br'),_vm._v("揭密台灣民間妖怪傳說故事")]),_c('h3',[_vm._v("你知道台灣也有自己的鬼怪文化嗎？民視新聞網特別製作台灣民俗月專題，用心理測驗跟專家訪談介紹台灣的本土文化、揭密台灣豐富的妖怪傳說。")]),_c('a',{attrs:{"href":"#section"}},[_vm._v("了解更多")]),_c('br'),_c('a',{attrs:{"href":"#aaa"}},[_vm._v("心理測驗")])])])
}]

export { render, staticRenderFns }